import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navigation } from "@/components/Navigation";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Hero } from "@/components/Hero";
import { Vision } from "@/components/Vision";
import { Pillars } from "@/components/Pillars";
import { Arrival } from "@/components/Arrival";
import { Location } from "@/components/Location";
import { Storytelling } from "@/components/Storytelling";
import { Reset } from "@/components/Reset";
import { Thoughtful } from "@/components/Thoughtful";
import { Investor } from "@/components/Investor";
import { Waitlist } from "@/components/Waitlist";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";

const Landing = () => (
  <SmoothScroll>
    <main data-testid="landing-page" className="bg-ivory text-forest">
      <Navigation />
      <Hero />
      <Vision />
      <Pillars />
      <Arrival />
      <Location />
      <Storytelling />
      <Reset />
      <Thoughtful />
      <Investor />
      <Waitlist />
      <Footer />
    </main>
  </SmoothScroll>
);

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster theme="light" position="bottom-center" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
